import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';

const ValidatedTextField = ({
	name,
	label,
	type = 'text',
	formData,
	errors,
	handleInputChange,
	handleInputBlur,
	...props
}) => {
	return (
		<TextField
			fullWidth
			type={type}
			name={name}
			label={label}
			value={formData[name] || ''}
			error={!!errors[name]}
			helperText={errors[name] || ''}
			onChange={(e) => handleInputChange(name, e.target.value)}
			onBlur={(e) => handleInputBlur(name, e.target.value)}
			{...props}
		/>
	);
};

ValidatedTextField.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	type: PropTypes.string,
	formData: PropTypes.object.isRequired,
	errors: PropTypes.object.isRequired,
	handleInputChange: PropTypes.func.isRequired,
	handleInputBlur: PropTypes.func.isRequired
};

export default ValidatedTextField;
